<template>
<vx-card class="donut-chart-card p-0" style="overflow-x: auto; max-width: 100%;">
  <vs-row class="orientation" :class="orientation">
    <vs-col style="position: relative">
      <div class="donut flex mt-6" style="justify-content: center; position: relative">
        <apexchart type="donut" :width="donutWidth" :options="donutOptions.chartOptions" :series="donutOptions.series" ></apexchart>
        <div style="position: absolute; top:0; right:0; left:0; bottom:0; justify-content: center; align-items: center; display: flex; ">
          <div v-if="donutValue > -1" class="total">
            <div class="total-value">{{ `${donutValue}` | comma }}</div>
            <div class="total-unit">{{ donutUnit }}</div>
          </div>
          <div v-else class="total">
            <div class="total-value">{{ `${total}` | comma }}</div>
            <div class="total-unit">{{ unit }}</div>
          </div>
        </div>
      </div>
      <ul class="datas">
        <li v-for="(data, index) in realValue" :key="`donut_${index}`" @click="onClickItem(data)">
          <donut-chart-label :label="dataGroup.labels[index]" :unit="unit" :value="dataGroup.values[index] | comma" :color="dataGroup.colors[index]" />
        </li>
      </ul>

      <div class="donut-chart-card-footer">
        <div class="my-2" style="height:1px; background-color: #E6E9F4"></div>
        <donut-chart-label label="누적" :unit="unit" :value="`${total}` | comma" color="#535767" />
      </div>

      <!-- header tools -->
      <div class="donut-chart-card-header">
        <span class="header-title"><i class="dot"></i>{{ title }}</span>
        <div style="justify-content: end">
          <!--  TODO: 임시로 숨겨둠 -->
          <a href="javascript:;" v-if="isMoveDetail && projectId" style="font-size:0.85em; display:flex; align-items: center; justify-content: flex-end;" @click="onClickDetail">자세히 보기<feather-icon icon="ChevronRightIcon" style="width:1.42em;"/></a>
<!--          <a v-if="isMoveWrite" href="javascript:;" style="font-size:0.85em; display:flex; align-items: center; justify-content: flex-end;" @click="onClickWrite">작성페이지 이동<feather-icon icon="ChevronRightIcon" style="width:1.42em;"/></a>-->
        </div>
      </div>
    </vs-col>
  </vs-row>

</vx-card>
</template>

<script>
import DonutChartLabel from '@/popup/DonutChartLabel'
export default {
  name: 'DonutChartCard',
  components: {DonutChartLabel},
  props: {
    size: String,
    title: String,
    unit: String,
    // 도넛차트 가운데에만 표시되는 값
    donutValue: {
      type: Number,
      default: -1,
    },
    // 도넛차트 가운데에만 표시되는 단위
    donutUnit: {
      type: String,
      default: '',
    },
    initTotal: {
      type: Number | String,
      default: '-1'
    },
    value: Array,
    isMoveDetail: {
      type:Boolean,
      default: true
    },
    isMoveWrite: Boolean,
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
  },
  data () {
    return {
    }
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    myLv () {
      return this.$store.state.auth.userInfo.position
    },

    total () {
      if (Number(`${this.initTotal}`) > -1) {
        return this.initTotal
      }

      let sum = 0
      try {
        for (const data of this.value) {
          const num = Number(`${data.value}`)
          if (!isNaN(num)) {
            sum += Number(`${data.value}`)
          }
        }
      } catch (ignore) {
        // ignore
      }
      return sum
    },

    realValue () {
      const maxLength = 5

      if (this.value.length) {
        const value = JSON.parse(JSON.stringify(this.value))
        if (value.length > maxLength) {
          return value.slice(0, maxLength)
        }
        return value
      } else {
        return [{label: '데이터 없음', value: 0}]
      }
    },

    dataGroup () {
      const labels = []
      const colors = ['#0058FF', '#F99600', '#FFC700', '#21D59B', '#F0142F']
      const values = []

      this.realValue.map(value => {
        if (value.label) labels.push(value.label)
        if (value.value || value.value === 0) {
          values.push(value.value)
        }
      })

      return { labels, colors, values }
    },

    donutWidth () {
      if (this.size === 'small') {
        return 200
      } else if (this.size === 'medium') {
        return 250
      } else if (this.size === 'large') {
        return 600
      }

      return 250
    },

    donutOptions () {
      return {
        series: this.dataGroup.values,
        chartOptions: {
          plotOptions: {
            pie:{
              donut:{
                size: '85%'
              }
            }
          },
          chart: {
            redrawOnParentResize: false,
            redrawOnWindowResize: false,

            type: 'donut'
          },
          dataLabels: {
            enabled: false
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  show: false
                }
              }
            }
          ],
          colors: this.dataGroup.colors,
          labels: this.dataGroup.labels,
          legend: { show: false }
        }
      }
    }

  },

  methods: {
    onClickDetail () {
      this.$emit('detail')
    },
    onClickWrite () {
      this.$emit('write')
    },
    onClickItem (data) {
      this.$emit('item', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.orientation { padding: 0rem;}
.donut-chart-card {
  position: relative;

  .total {
    display: grid;
    justify-content: center;
    align-items: center;
    text-align: center;

    .total-value {
      font-size: 1.71em;
      font-weight: bold;
      color:#000
    }

    .total-unit {
      font-size: 1em;
      font-weight: bold;
      color:#757575
    }
  }

  .donut { width: 100%; }
}
.datas {
  height: 140px;
}
.donut-chart-card-header {
  display: flex;
  justify-content: space-between;
  align-items: start;

  position: absolute;
  top:0;
  left:0;
  right:0;

  .header-title {
    font-weight: bold;
    font-size: 1em; display: flex; align-items: center;
  }
}
.donut-chart-card-footer {
  position: absolute;
  bottom:0;
  left:0;
  right:0;
}

/* 가로모드 */
.landscape {
  padding: 3rem 5.5rem;
  height: 786px;

  & > .vs-col { display: grid; grid-template-columns: auto 1fr;}
  .donut-chart-card-header {
    .header-title { font-size: 4rem; }
    .header-title > .dot { width: 1.75rem; height: 1.75rem;}
  }

  .donut {
    padding-top: 5.25rem;
    width: auto;
  }

  .datas {
    padding-top: calc(5.25rem + 2.25rem);

    li { padding-bottom: 2rem; font-size: 3.5rem;}
  }

  .donut-chart-card-footer {
    left: 600px;
    bottom: 1rem;
    font-size: 3.5rem;
  }
}
</style>
